import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Disables the native back button (Android hardware back button, iOS swipe-to-go-back,
 * and browser back button) globally across all screens in the web app.
 */
export const useDisableNativeBackButton = () => {
  const location = useLocation();

  useEffect(() => {
    // Push current location state to trap back button navigation
    window.history.pushState(null, "", window.location.href);

    const handlePopState = () => {
      // Re-push current state whenever native back action is attempted
      window.history.pushState(null, "", window.location.href);
    };

    const handlePageShow = (event) => {
      // Handles iOS Safari BFCache restoration when swipe-back gesture is used
      if (event.persisted) {
        window.history.pushState(null, "", window.location.href);
      }
    };

    window.addEventListener("popstate", handlePopState);
    window.addEventListener("pageshow", handlePageShow);

    return () => {
      window.removeEventListener("popstate", handlePopState);
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, [location.pathname, location.search]);
};

export default useDisableNativeBackButton;
